import {auth, authManager} from './auth'

import ClassroomTicketsPage from '@/views/ClassroomTicketsPage'
import Error from '@/views/Error'
import ManagerGroupsTicketsPage from '@/views/ManagerGroupsTicketsPage'
import ManagerGroupsHistoryTicketsPage from '@/views/ManagerGroupsHistoryTicketsPage'
import Menu from '@/components/Navbar'
import Router from 'vue-router'
import TicketPage from '@/views/TicketPage'
import UserTicketsPage from '@/views/UserTicketsPage'
import Vue from 'vue'

Vue.use(Router)

const router = new Router({
    base: '/tiquets/',
    routes: [
        {
            path: '*',
            name: 'NotFoundPage',
            components: {
                default: Error,
                menu: Menu
            },
            meta: {
                requiresAuth: true,
                title: 'Tiquets - Pàgina no trobada'
            }
        },
        {
            path: '/error/:code',
            name: 'Error',
            components: {
                default: Error,
                menu: Menu
            },
            meta: {
                requiresAuth: true,
                title: 'Tiquets - Error'
            }
        },
        {
            path: '/manager/grups',
            name: 'ManagerGroupsTicketsPage',
            components: {
                default: ManagerGroupsTicketsPage,
                menu: Menu
            },
            meta: {
                requiresManager: true,
                title: 'Tiquets - Incidències a gestionar'
            }
        },
        {
            path: '/manager/grups/history',
            name: 'ManagerGroupsHistoryTicketsPage',
            components: {
                default: ManagerGroupsHistoryTicketsPage,
                menu: Menu
            },
            meta: {
                requiresManager: true,
                title: 'Tiquets - Històric d\'incidències'
            }
        },
        {
            path: '/',
            name: 'UserTicketsPage',
            components: {
                default: UserTicketsPage,
                menu: Menu
            },
            meta: {
                requiresAuth: true,
                title: 'Tiquets - Les meves incidències'
            }
        },
        {
            path: '/tiquet/:id',
            name: 'TicketPage',
            components: {
                default: TicketPage,
                menu: Menu
            },
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Tiquets - Incidència'
            }
        },
        {
            path: '/aula',
            name: 'ClassroomTicketsPage',
            components: {
                default: ClassroomTicketsPage,
                menu: Menu
            },
            props: true,
            meta: {
                requiresAuth: true,
                title: 'Tiquets - Incidències per aula'
            }
        }
    ],
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        auth(to, from, next, function () {
            next()
        })
    } else if (to.matched.some(record => record.meta.requiresManager)) {
        authManager(to, from, next)
    } else {
        next()
    }

    // Canviar el títol de la pàgina
    if (to.meta.title) {
        let title = to.meta.title;
        if (to.params.id) {
            title += ` ${to.params.id}`;
        }
        document.title = title;
    }

})

export default router
